module.exports = __webpack_public_path__ + "img/menu_background.b048690e.png";